import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(localStorage.getItem('preferred_currency') || 'IDR');
  const [exchangeRate, setExchangeRate] = useState(15800); // Default rate: 1 USD = 15.800 IDR

  useEffect(() => {
    localStorage.setItem('preferred_currency', currency);
    console.log("Currency changed to:", currency); // For debugging
  }, [currency]);

  const formatPrice = (priceInIdr) => {
    const numericPrice = parseFloat(priceInIdr);
    if (isNaN(numericPrice)) return "Rp 0";

    if (currency === 'USD') {
      const priceInUsd = numericPrice / exchangeRate;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(priceInUsd);
    }
    
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      maximumFractionDigits: 0
    }).format(numericPrice).replace('Rp', 'Rp ');
  };

  const toggleCurrency = () => {
    setCurrency(prev => {
        const next = prev === 'IDR' ? 'USD' : 'IDR';
        console.log("Toggling currency to:", next); // For debugging
        return next;
    });
  };

  return (
    <CurrencyContext.Provider value={{ currency, toggleCurrency, formatPrice, setExchangeRate }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
